export default "__VITE_ASSET__BKJUwNU3__"